import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Plus, X } from "lucide-react";

export default function ListEditor({ items, onChange, placeholder, testid, color = "primary" }) {
  const [value, setValue] = useState("");

  const add = () => {
    const v = value.trim();
    if (!v) return;
    onChange([...items, v]);
    setValue("");
  };

  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <Input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              add();
            }
          }}
          placeholder={placeholder}
          data-testid={`${testid}-input`}
        />
        <Button
          type="button"
          variant="secondary"
          size="icon"
          className="shrink-0 rounded-lg"
          onClick={add}
          data-testid={`${testid}-add-btn`}
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>
      {items.length > 0 && (
        <ul className="space-y-1.5" data-testid={`${testid}-list`}>
          {items.map((item, i) => (
            <li
              key={i}
              className="flex items-start gap-2 text-sm bg-secondary/60 rounded-lg px-3 py-2 group"
            >
              <span
                className={`mt-1.5 h-1.5 w-1.5 rounded-full shrink-0 bg-${color}`}
                style={{
                  backgroundColor:
                    color === "destructive"
                      ? "hsl(var(--destructive))"
                      : color === "chart-2"
                      ? "hsl(var(--chart-2))"
                      : "hsl(var(--primary))",
                }}
              />
              <span className="flex-1 break-words">{item}</span>
              <button
                type="button"
                onClick={() => remove(i)}
                className="opacity-0 group-hover:opacity-100 transition-opacity text-muted-foreground hover:text-destructive"
                data-testid={`${testid}-remove-${i}`}
              >
                <X className="h-4 w-4" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
